/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_Application_Unknown_ErrorInputs */

const en_submit_application_unknown_error = /** @type {(inputs: Submit_Application_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown error when submitting the application.`)
};

const de_submit_application_unknown_error = /** @type {(inputs: Submit_Application_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Fehler beim Einreichen der Bewerbung.`)
};

/**
* | output |
* | --- |
* | "Unknown error when submitting the application." |
*
* @param {Submit_Application_Unknown_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const submit_application_unknown_error = /** @type {((inputs?: Submit_Application_Unknown_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Application_Unknown_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_submit_application_unknown_error(inputs)
	return en_submit_application_unknown_error(inputs)
});